module.exports = __webpack_public_path__ + "img/chat_bg22.8dfe61cc.png";